'use client';

import { Group, Rating, Stack, Title, rem } from '@mantine/core';
import { useMemo } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { RATING_LABELS, type RatingFormData } from './types';
import IconStarGrey from '@/assets/icons/star-grey.svg';
import IconStarYellow from '@/assets/icons/star-yellow.svg';

export function StarRatingSection() {
  const { control, watch } = useFormContext<RatingFormData>();
  const rating = watch('rating');

  const ratingLabel = useMemo(() => {
    return RATING_LABELS[rating] || '';
  }, [rating]);

  return (
    <Stack gap={0} p={0} style={{ zIndex: 1 }}>
      <Stack gap={12} pt={rem(16)}>
        <Title order={3} lineClamp={1} style={{ textAlign: 'center' }}>
          {ratingLabel}
        </Title>
        <Group justify="center" align="center" gap={0}>
          <Controller
            name="rating"
            control={control}
            render={({ field }) => (
              <Rating
                value={field.value}
                onChange={field.onChange}
                emptySymbol={<IconStarGrey size={40} />}
                fullSymbol={<IconStarYellow size={40} />}
                styles={{
                  root: {
                    gap: rem(12),
                  },
                }}
              />
            )}
          />
        </Group>
      </Stack>
    </Stack>
  );
}
